<template>
  <el-date-picker
    v-model="selectTime"
    :clearable="clearable"
    :disabled-date="disabledDate"
    end-placeholder="结束日期"
    range-separator="~"
    start-placeholder="开始日期"
    type="daterange"
    value-format="x"
    @calendar-change="handleCalendarChange"
    @change="handleChange"
    @visible-change="handleVisibleChange"
  >
  </el-date-picker>
</template>

<script setup>
import { ref, computed } from 'vue'

defineOptions({
  name: 'TimeSelect'
})

const props = defineProps({
  timeInterval: {
    type: Number,
    default: 30
  },
  value: {
    type: Array,
    default: () => []
  },
  clearable: {
    type: Boolean,
    default: false
  },
  isLimitRange: {
    type: Boolean,
    default: true
  }
})

const emits = defineEmits(['update:value', 'change'])

const chooseDay = ref(null)

const handleVisibleChange = (val) => {
  if (val) {
    chooseDay.value = null
  }
}

const handleCalendarChange = (val) => {
  const [chooseStart] = val
  chooseDay.value = new Date(chooseStart)
}

const disabledDate = (time) => {
  if (!chooseDay.value || !props.isLimitRange) {
    return false
  }
  return (
    time.getTime() > chooseDay.value.getTime() + props.timeInterval * 24 * 60 * 60 * 1000 ||
    time.getTime() < chooseDay.value.getTime() - props.timeInterval * 24 * 60 * 60 * 1000
  )
}

const selectTime = computed({
  get() {
    return props.value
  },
  set(val) {
    console.log('handleChange', val)
    emits('update:value', val)
  }
})

const handleChange = () => {
  emits('change')
}
</script>

<style lang="scss" scoped></style>
